import React from 'react';
import { LinkType } from '../../../utils/analytics/types';
import { Link, Text } from './styled';
function Path(_ref) {
  var text = _ref.text,
    url = _ref.url,
    onClick = _ref.onClick;
  var handleClick = function handleClick(clickType) {
    return function (event) {
      if (url) {
        onClick(LinkType.PATH, clickType, event);
      }
    };
  };
  return /*#__PURE__*/React.createElement(Link, {
    href: url,
    onClick: handleClick('left'),
    onAuxClick: handleClick('middle'),
    onContextMenu: handleClick('right'),
    "data-testid": "notification-item-path-link"
  }, /*#__PURE__*/React.createElement(Text, {
    "data-testid": "notification-item-path-text"
  }, text));
}
export default Path;